<template>
    <section class="locations">
        <div class="tabs">
            <a
                v-for="(groupedLocations, type) in locations"
                :key="type"
                class="tab"
                :class="{active: selectedTab == type}"
                @click.prevent="selectedTab = type"
            >
                {{ type }}
            </a>
        </div>
        <div
            v-for="(groupedLocations, type) in locations"
            v-show="selectedTab == type"
            :key="type"
            class="listing"
        >
            <div v-for="(location, index) in groupedLocations" :key="index" class="location">
                <a href="#" class="link">
                    <img width="512" height="341" :src="location.avatar" :alt="location.building_name" />
                    <h3 v-if="location.building_name">{{ location.building_name }}</h3>
                    <p>
                        <template v-if="location.address && location.address.length">
                            <span v-html="withLineBreaks(location.address)"></span>
                            <br />
                        </template>
                        <a :href="`tel:${location.phone_clickable}`"><strong v-if="location.phone">{{ location.phone }}</strong></a>
                    </p>
                    <div class="footer">
                        <span>Explorer</span>
                        <i aria-hidden="true" class="fas fa-chevron-right"></i>
                    </div>
                </a>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    props: {
        locations: {type: Object, required: true},
    },

    data() {
        return {
            selectedTab: this.firstTab(),
        };
    },

    methods: {
        firstTab() {
            const types = Object.keys(this.locations);

            return types.length ? types[0] : null;
        },

        withLineBreaks(value) {
            return value.join('<br />');
        },
    },
};
</script>
